import type { RouteObject } from 'react-router';
import { AdminOrganizationsPage } from '../pages/admin-organizations-page';

export const adminOrganizationsRoutes: RouteObject[] = [
  { path: 'organizations', element: <AdminOrganizationsPage /> },
];
